<style>
div{
  white-space: pre-line !important
}
.el-timeline-item__timestamp.is-bottom {
  margin-top: -5px!important;
}
</style>
<template>
 <el-row>

     <el-row :gutter="1" type="flex" class="row-bg" justify="center">
       <el-col :span="18">

         <div  style="border: #13305D 1px solid;border-radius: 10px;margin-top: 15px;margin-right: 0px;margin-bottom: 10px">
            <p style="font-size: 25px;margin: 05px 10px 5px 20px;font-weight: bold;color: #A20000;text-align: center">Welcome to RNAPhaSep !</p>
            <el-divider></el-divider>
            <p style="font-size: 20px;margin: 5px 20px 0px;text-align:justify;font-family: 'Arial'">Biomolecular condensation partitions cellular contents and plays essential roles in stress responses, maintaining homeostasis, development and disease. Most studies focused on RNA-binding proteins in driving phase separation. However, in recent years accumulating evidence demonstrated that RNAs could also function as ‘scaffolds’ and contribute to seed or nucleate the formation of granules. </p>

            <p style="font-size: 20px;margin: 5px 20px 0px;text-align:justify;font-family: 'Arial'">It is crucial to systematically summarize all the available experimental data to better understand RNAs’ role in phase separation. RNAPhaSep is a novel database that collects phase separation related RNAs manually curated from publication and public databases. Various properties of RNAs together with the corresponding phase separation conditions validated by experiments were collected and deposited into this database.</p>
           <el-row :gutter="1" type="flex" class="row-bg" justify="center">

<!--               <img src="../../assets/img/back111.png" width="90%" style="margin-top: 10px;margin-bottom: 10px" />-->

               <embed style="margin-top:0px" src="http://www.rnaphasep.cn/static/img/home2.svg"
                    width="95%" height="100%">

           </el-row>

         </div>
       </el-col>

       <el-col :span="5" style="padding-left: 20px" >
           <el-col :span="24" class="grid-content bg-purple" style="border: #13305D 1px solid;border-radius: 10px;margin-top: 15px;color: #606266;">
             <p style="font-size: 25px;margin: 5px 10px 5px 20px;font-weight: bold;color: #13305D">News</p>
             <el-divider></el-divider>
             <el-timeline style="margin-top: 11px;margin-bottom: 0px;">
               <el-timeline-item
                   v-for="(activity, index) in activities"
                   :key="index"
                   :icon="activity.icon"
                   :type="activity.type"
                   :color="activity.color"
                   :size="activity.size"
                   :timestamp="activity.timestamp">
                 {{activity.content}}
               </el-timeline-item>
             </el-timeline>
           </el-col>


           <el-col class="grid-content bg-purple" style="border: #13305D 1px solid;border-radius: 10px;margin-top: 22px;margin-right: 0px">
             <p style="font-size: 25px;margin: 5px 10px 5px 20px;font-weight: bold;color: #13305D;text-align:justify">Sister Databases</p>
             <el-divider></el-divider>
             <p style="margin-left: 15px;margin-top: 0px;margin-bottom: 0px"><el-link style="font-size: 14px" target="_blank" href="http://www.rna-society.org/cncrnadb/"><i class="el-icon-view el-icon--right"></i> cncRNADB (NAR. 2021)</el-link></p>
             <p style="margin-left: 15px;margin-top: 0px;margin-bottom: 0px"><el-link style="font-size: 14px" target="_blank" href="http://www.rna-society.org/mndr/"><i class="el-icon-view el-icon--right"></i> MNDR v3.0 (NAR. 2021)</el-link></p>
             <p style="margin-left: 15px;margin-top: 0px;margin-bottom: 0px"><el-link style="font-size: 14px" target="_blank" href="http://www.rna-society.org/rnainter/"><i class="el-icon-view el-icon--right"></i> RNAInter (NAR. 2020)</el-link></p>
             <p style="margin-left: 15px;margin-top: 0px;margin-bottom: 0px"><el-link style="font-size: 14px" target="_blank" href="http://www.rna-society.org/rnalocate/index.html"><i class="el-icon-view el-icon--right"></i> RNALocate (NAR. 2017)</el-link></p>
             <p style="margin-left: 15px;margin-top: 0px;margin-bottom: 0px"><el-link style="font-size: 14px" target="_blank" href="http://www.rna-society.org/virbase/"><i class="el-icon-view el-icon--right"></i> ViRBase (NAR. 2015)</el-link></p>
             <p style="margin-left: 15px;margin-top: 0px;margin-bottom: 15px"><el-link style="font-size: 14px" target="_blank" href="http://www.rna-society.org/ncrdeathdb/"><i class="el-icon-view el-icon--right"></i> ncRDeathDB (Autophagy. 2015)</el-link></p>
           </el-col>



       </el-col>
     </el-row>
      <el-row :gutter="1" type="flex" class="row-bg" justify="center">
        <el-col :span="23">
        <div  style="border: #13305D 1px solid;border-radius: 10px;margin-top: 5px;margin-bottom: 10px">
          <a style="font-size: 25px;margin: 5px 10px 5px 15px;font-weight: bold;color: #13305D;">Citation:</a><a style="font-size: 20px;color: black;text-align:justify;line-height:40px">RNAPhaSep: a resource of RNAs undergoing phase separation. Nucleic Acids Research. 2021. doi: 10.1093/nar/gkab985. </a>
        </div>
        </el-col>
      </el-row>

 </el-row>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
        input: '',
        activities: [
          {
            content: 'RNAPhaSep Version 1.0',
            timestamp: '2021-08',
            color: '#0bbd87'
          },{
          content: 'Data update\n' +
              'Updated: NORAD, SARS-CoV-2 virus RNA.\n' +
              'New Added: ACTG2, SLC38A2, PUM1, PUM2, SNHG9.\n' +
              'A total of 325 RNAs of 22 organisms and 1113 entries were included.',
          timestamp: '2021-07',
            color: '#E6A23C',

        }, {
          content: 'Data collection completed',
          timestamp: '2021-03'
        }]
    }
  },
  methods: {

  }
}
</script>

<style scoped>
div
{
  overflow-y:auto;
  overflow-x: hidden;
}

.el-cascader{
  overflow-y: hidden;
  width: 200px;
}
.el-cascader--medium{
  line-height: 40px;
}
.el-input__inner{
  height: 41px;
}
a{
  text-decoration: none;
  color: #409eff;
}
.el-divider--horizontal{
  margin-top:5px ;
  margin-bottom: 0px;
  margin-left: 0px;
  background: 0 ;
  border-top: 1px  solid #13305D;
}
.el-timeline-item{
  padding-bottom: 15px;
}
ul.el-timeline{
  padding-left: 5%;
}

.home{
  background: url("../../assets/img/home.png"),repeat-x,repeat-y;
  background-size:100% 100%;
}


</style>